import { ref } from 'vue'
import { userGlobalState } from './store'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { useInjectionAuth } from './utils/injection'
import { MenuType } from "./utils/interface";
const proEnv = import.meta.env;
const isPRD = (["PRD", "PRE", "production"].includes(proEnv.VITE_NODE_ENV));
let testAccount = ref("");

// 获取store的数据
const globalState = userGlobalState()
const stateInfo = globalState.state
// 存储个人信息
export const userInit = (account: string) => {
	if (isPRD) {
		return
	}
	// 调试模式用户账号
	if (account) {
		testAccount.value = account
	}
}
// 协助校验object是否为空
function isEmpty(obj: object): boolean {
	return Object.keys(obj).length === 0;
}

// 个人信息、权限校验
async function routerValidate(_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext, noPermissionCallback?: Function) {
	let authState = "continue"
	let menus = [] as MenuType[]
	// 调试模式下走loginForSimulator接口

	//改成同步 async awit
	if (!stateInfo.testStatu && testAccount.value) {
		await globalState.initAccount(testAccount.value)
		// 账号设置为空，避免重复调用initAccount方法
		testAccount.value = ""
	}
	// 非调试模式下走selPersonDetailAndOrg接口, 新增testAccount.value判断，避免将testAccount.value设置为空后，直接走getUserInfo接口
	if (isEmpty(stateInfo.userInfo)) {
		await globalState.getUserInfo()
	}
	// 判断是否有菜单信息
	if (_to.path !== '/403' && (menus.length == 0 || stateInfo.userMenu.length == 0)) {
		let account = stateInfo.userInfo.personCode
		menus = await globalState.getUserMenuList(account).then((data: MenuType[]) => {
			return data
		})
		if (menus && menus.length == 0) {
			authState = "noPermission"
			if (_to.path === "/403") {
				next();
			}else {
				next("/403");
			}
		} else {
			next();
		}
		// 自定义403
		if (authState == "noPermission" && noPermissionCallback) {
			noPermissionCallback()
		}
	} else {
		next();
	}

	return authState
}

export * from "./utils/interface"
export default {
	userInit,
	routerValidate,
	useInjectionAuth,
	userGlobalState
}